<script lang="ts">import { isMobile } from "@infinitro/global";
import { Text } from "@infinitro/text";
import VipBenefitsCard from "./vip-benefits-card.svelte";
export let title;
export let description;
export let image;
export let descriptionMaxWidth = "80%";
const getMobileImage = (desktopImage) => {
	const pngMatch = desktopImage.match(/(\.png)(\?.*)?$/);
	if (pngMatch) {
		const [, extension, query = ""] = pngMatch;
		return desktopImage.replace(/(\.png)(\?.*)?$/, `-mobile${extension}${query}`);
	}
	const genericMatch = desktopImage.match(/(\.[^./?]+)(\?.*)?$/);
	if (genericMatch) {
		const [, extension, query = ""] = genericMatch;
		return desktopImage.replace(/(\.[^./?]+)(\?.*)?$/, `-mobile${extension}${query}`);
	}
	return `${desktopImage}-mobile.png`;
};
$: currentImage = $isMobile ? getMobileImage(image) : image;
</script>

{#key $isMobile}
	<VipBenefitsCard contentPadding="0px">
		<div
			class="vip-benefit-section-2-content {$isMobile
				? 'vip-benefit-section-2-content-mobile'
				: ''}"
		>
			{#if $isMobile}
				<div class="vip-benefit-section-2-content-text-mobile">
					<Text type="subtitle" subtitleSize="small" subtitleWeight="semibold" textAlign="center"
						>{title}</Text
					>

					<Text
						type="body"
						bodySize="small"
						textAlign="center"
						customStyle={`max-width: ${descriptionMaxWidth}`}
					>
						{description}
					</Text>
				</div>

				<img src={currentImage} alt={title} class="vip-benefit-image-mobile" />
			{:else}
				<div class="vip-benefit-section-2-content-text">
					<Text type={'subtitle'} subtitleSize={'large'} subtitleWeight="semibold" textAlign="start"
						>{title}</Text
					>

					<Text
						type="body"
						bodySize={'large'}
						textAlign="start"
						customStyle={`max-width: ${descriptionMaxWidth}`}
					>
						{description}
					</Text>
				</div>

				<img src={currentImage} alt={title} class="vip-benefit-image" />
			{/if}
		</div>
	</VipBenefitsCard>
{/key}

<style>
	.vip-benefit-section-2-content {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: flex-end;
		overflow: hidden
}

	.vip-benefit-section-2-content-mobile {
		display: flex;
		height: 100%;
		min-height: 280px;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		padding-left: 0.75rem;
		padding-right: 0.75rem;
		padding-top: 1rem
}

	.vip-benefit-image {
		position: absolute;
		left: 0px;
		top: 0px;
		height: 100%;
		width: auto;
		-o-object-fit: cover;
		   object-fit: cover;
		z-index: 0
}

	.vip-benefit-image-mobile {
		position: absolute;
		bottom: 0px;
		left: 0px;
		height: auto;
		width: 100%;
		-o-object-fit: contain;
		   object-fit: contain;
		z-index: 1
}

	.vip-benefit-section-2-content-text {
		display: flex;
		height: 100%;
		width: 45%;
		flex-direction: column;
		justify-content: center;
		gap: 0.5rem;
		z-index: 1
}

	.vip-benefit-section-2-content-text-mobile {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 0.5rem;
		z-index: 1
}

	@media (min-width: 1024px) {
		.vip-benefit-section-2-content {
				height: 100%
		}

		.vip-benefit-section-2-content-text {
				width: 40%;
				gap: 2rem
		}

		.vip-benefit-image {
				height: 100%;
				width: auto
		}
	}
</style>
